// Path: ./src/app/pages/CreateMerchantPage/handleSaveMerchant.ts
import { UpdateGfMerchantDto } from "@swagger/typescript-fetch-goflyer";
import { toastError, toastSuccess } from "../../../utils/pageUtil/toast";
import { messages } from "../../../locales/messages";
import { adminApiService } from "../../../utils/api";
import i18n from "i18next";
import { useLoading } from "../../../contextApi/LoadingContext";
import { useNavigate } from "react-router-dom";
import { useAuthHeaders } from "../../../hooks/useAuthHeaders";

export const useHandleSaveMerchant = () => {
  const navigate = useNavigate();
  const { showLoadingScreen } = useLoading();
  const authHeaders = useAuthHeaders();

  const handleSaveMerchant = async (updateMerchant?: UpdateGfMerchantDto) => {
    if (!updateMerchant?.name) {
      toastError(`${i18n.t(messages.name())} ${i18n.t(messages.is_Empty())}`);
      return;
    }
    if (!updateMerchant?.nameChinese) {
      toastError(
        `${i18n.t(messages.nameChinese())} ${i18n.t(messages.is_Empty())}`,
      );
      return;
    }
    if (!updateMerchant?.domain) {
      toastError(`${i18n.t(messages.domain())} ${i18n.t(messages.is_Empty())}`);
      return;
    }
    if (!updateMerchant?.merchantMapSmallLogo) {
      toastError(
        `${i18n.t(messages.gfImages())} ${i18n.t(messages.is_Empty())}`,
      );
      return;
    }

    if (!updateMerchant?.merchantLogo) {
      toastError(
        `${i18n.t(messages.gfImages())} ${i18n.t(messages.is_Empty())}`,
      ); //TODO, replace translation
      return;
    }
    if (!updateMerchant?.merchantMapLargeLogo) {
      toastError(
        `${i18n.t(messages.gfImages())} ${i18n.t(messages.is_Empty())}`,
      ); //TODO, replace translation
      return;
    }

    const payload = {
      ...updateMerchant,
      aiCoordinationMode:
        updateMerchant.aiCoordinationMode ??
        (null as unknown as UpdateGfMerchantDto["aiCoordinationMode"]),
      smartFlyerModelOverride:
        updateMerchant.smartFlyerModelOverride ??
        (null as unknown as UpdateGfMerchantDto["smartFlyerModelOverride"]),
    } as UpdateGfMerchantDto;

    showLoadingScreen(true);
    payload.id
      ? await adminApiService.updateOneBaseGfMerchantAdminControllerGfMerchant(
          payload,
          payload.id,
          authHeaders,
        )
      : await adminApiService.createOneBaseGfMerchantAdminControllerGfMerchant({
          ...payload, //This is for optional properties
          name: payload.name!,
          nameChinese: payload.nameChinese!,
          domain: payload.domain!,
          merchantMapSmallLogo: payload.merchantMapSmallLogo!,
          merchantLogo: payload.merchantLogo!,
          merchantMapLargeLogo: payload.merchantMapLargeLogo!,
        });
    showLoadingScreen(false);
    toastSuccess(`Successfully created merchant`); //TODO: (if you touch code here, please refactor. if you don't know the issue, please talk to me) missing translation here
    navigate(-1);
  };
  return handleSaveMerchant;
};
